<script>
    export let stamp
    import moment from 'moment'

    const get_expiration = stamp => {
        stamp = moment(stamp)
        if (stamp.isBefore()) {
            return `Expired!`
        }

        return `Expires ${stamp.fromNow()}`
    }
</script>

<span>{get_expiration(stamp)}</span>
